import { render, staticRenderFns } from "./PositionBtn.vue?vue&type=template&id=6942c076&scoped=true&"
import script from "./PositionBtn.vue?vue&type=script&lang=js&"
export * from "./PositionBtn.vue?vue&type=script&lang=js&"
import style0 from "./PositionBtn.vue?vue&type=style&index=0&id=6942c076&lang=less&scoped=true&"
import style1 from "./PositionBtn.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942c076",
  null
  
)

export default component.exports